import React, { useRef } from "react";
import { useTheme } from "@material-ui/core/styles";
import clsx from "clsx";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DragScroll from 'react-dragscroll';
import { CDN_URI } from "../common/utilities";
import styles from "./Pins.module.scss";

//returns object of pins to display with pin_id as keys
function getPinsData(data) {
  let pinsInfo = {};

  if (!data) {
    return pinsInfo;
  }

  data.sort((a, b) => (a.PIN_ORDER > b.PIN_ORDER ? 1 : -1));

  for (let item of data) {
    if (item.hasIt) {
      if (!pinsInfo.hasOwnProperty(`${item.PIN_ID}`)) {
        pinsInfo[`${item.PIN_ID}`] = {
          name: null,
          imgURL: null
        };
      }

      pinsInfo[`${item.PIN_ID}`]["name"] = item.PIN_DISPLAY_NAME;
      pinsInfo[`${item.PIN_ID}`][
        "imgURL"
      ] = `${CDN_URI}imgs/pins/pin_${item.PIN_ID}_${item.ribbonID}.png`;
    }
  }
  return pinsInfo;
}

export default function Pins({ data }) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));
  const tablet = useMediaQuery(theme.breakpoints.down("sm"));

  //contains all pins data to show for this player
  const pins = getPinsData(data);

  return (
    <div className={styles.drag_scroll_container}>
   <DragScroll width={'100%'} height={'auto'}>
     <div className={clsx(
        styles.pins_container,
        tablet && styles.tablet
     )}>
      {Object.keys(pins).map(pinID => (
        <div
          key={pinID}
          className={clsx(styles.pin_item, mobile && styles.mobile)}
        >
          <span>{pins[pinID].name}</span>
          <img src={pins[pinID].imgURL} />
        </div>
      ))}
      </div>
    </DragScroll>
    </div>
  );
}
